import LoginComponent from "@/components/Authentication/LoginComponent";
import React from "react";

const Login = () => {
  return (
    <div>
      <LoginComponent />
    </div>
  );
};

export default Login;
